module.exports = __webpack_public_path__ + "media/video401.6ba1ca09.mp4";